import getCurrentSubdomain from 'utils/get-current-subdomain';

const { REACT_APP_URL_DEFAULT_SUBDOMAIN } = process.env;

/**
 * Derives the Auth0 Organization name from the current subdomain.
 *
 * Enterprise subdomains (e.g. `contoso.development.farmbot.com.au`) map
 * directly to an Auth0 Organization whose name equals the subdomain.
 * The generic/default subdomain (e.g. `app`) returns `undefined` so
 * that Auth0 shows the standard login screen without organization scope.
 */
const getAuth0Organization = (): string | undefined => {
  const subdomain = getCurrentSubdomain();
  if (!subdomain || subdomain === REACT_APP_URL_DEFAULT_SUBDOMAIN) {
    return undefined;
  }
  return subdomain;
};

export default getAuth0Organization;
